export let AlgoliaAnalyticsTagsRepositories = /*#__PURE__*/function (AlgoliaAnalyticsTagsRepositories) {
  AlgoliaAnalyticsTagsRepositories["WebsiteClient"] = "repo:website-client";
  return AlgoliaAnalyticsTagsRepositories;
}({});

// generally base on the file name unless there's
// drastically different use cases in the one files
export let AlgoliaAnalyticsTagsUses = /*#__PURE__*/function (AlgoliaAnalyticsTagsUses) {
  AlgoliaAnalyticsTagsUses["SiteSearch"] = "use:site-search";
  AlgoliaAnalyticsTagsUses["LiveSearch"] = "use:live-search";
  return AlgoliaAnalyticsTagsUses;
}({});